import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {Customer} from '../../model/Entities/Customer';
import {Product} from '../../model/Entities/Product';
import {FormControl, Validators} from '@angular/forms';
import {numberValidator} from '../../validators/number.validator';
import {intValidator} from '../../validators/int.validator';
import {Contract} from '../../model/Entities/Contract';
import {CustomerService} from '../../services/customer.service';
import {CustomerContactPersonService} from '../../services/customer-contact-person.service';
import {Filter} from '../../model/Helpers/Filter';
import {CustomerContactPerson} from '../../model/Entities/CustomerContactPerson';
import {MailService} from '../../services/mail.service';
import {Email} from '../../model/Entities/Email';
import {SnackService} from '../../services/snack.service';
import {ConfigService} from '../../services/config.service';
import {UserService} from '../../services/user.service';
import {ContractEventService} from '../../services/event.service';
import {ContractEvent} from '../../model/Entities/ContractEvent';

@Component({
    selector: 'contract-event-dialog',
    templateUrl: './contract-event.dialog.component.html',
    styleUrls: ['./contract-event.dialog.component.scss']
})
export class ContractEventDialogComponent {

    private contract: Contract;
    contractEvent: ContractEvent = new ContractEvent();

    nameFC = new FormControl('', [
        Validators.required,
    ]);

    constructor(public dialog: MatDialogRef<ContractEventDialogComponent>,
                private contractEventService: ContractEventService,
                private snackService: SnackService,
                public CONFIG: ConfigService,
                @Inject(MAT_DIALOG_DATA) public data: any) {
        this.contract = data.contract;

        // console.log('EVENT ID', data.eventId);
        if (data.eventId !== null) {
            this.contractEventService.get(data.eventId).subscribe((e: ContractEvent) => {
                this.contractEvent = e;
            });
        }
    }

    checkValidity(): boolean {
        return this.nameFC.valid;
    }

    save(): void {
        this.dialog.close(this.contractEvent);
    }
}



// WEBPACK FOOTER //
// /app/src/ContractsModule/ContractEventDialogComponent/contract-event.dialog.component.ts